export default "__VITE_ASSET__DuDXhMXT__"